export default "__VITE_ASSET__CIZyb$Bb__"